<template>
    <div class="page online-store-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div>
                    <v-card flat class="bordered">
                        <v-card-title class="mb-1">
                            <v-icon color="primary" size="28" class="me-2">mdi-store</v-icon>
                            <span>المتجر الإلكتروني</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">تحكم بالمتجر الالكتروني الخاص بك وإعداداته ومظهره</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>
                        <v-card-text class="pb-6">
                            <v-alert v-if="subscription !== 'free' && !storeData.domain" type="info" color="primary" icon="mdi-web" dense outlined text class="mb-3" :to="{name: 'store-main-settings'}">
                                <div class="details-text">يمكنك الاستفادة من ميزة الدومين الخاص لمتجرك</div>
                            </v-alert>
                            <!-- {{storeData.storename}} -->
                            <v-list class="pa-0 transparent ma-0">
                                <v-list-item v-for="(link, i) in links" :key="i" :to="link.to" exact v-ripple="{class: 'ripple--color'}">
                                    <v-list-item-icon class="me-4 me-lg-6">
                                        <v-icon :color="link.color || 'strong-text'" size="26">{{link.icon}}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{link.title}}</v-list-item-title>
                                        <v-list-item-subtitle class="details-text">{{link.subtitle}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                        <v-icon color="muted" size="20">mdi-chevron-left</v-icon>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </div>
            </transition>
      </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'


export default {
    name: "OnlineStore",
    components: {
        
    },
    data(){
        return {
            loading: false,
            links: [
                {icon: 'mdi-store-cog-outline', color: 'primary', title: 'إعدادات المتجر اﻷساسية', subtitle: 'اﻹعدادات اﻷساسية للمتجر (الشعار، الرابط، الاسم..)', to: {name: 'store-main-settings'}},
                {icon: 'mdi-application-cog-outline', color: 'purple', title: 'المظهر وواجهة المتجر', subtitle: 'إعدادات تصميم واجهة المتجر اﻷمامية والقالب', to: {name: 'store-theme-settings'}},
                {icon: 'mdi-truck-delivery-outline', color: 'error', title: 'إعدادات الشحن والتوصيل', subtitle: 'إعدادات الشحن وتوصيل الطلبات وتكلفة التوصيل', to: {name: 'delivery-areas'}},
                {icon: 'mdi-magnify-expand', color: 'blue darken-1', title: 'إعدادات SEO (محركات البحث)', subtitle: 'الظهور على محركات البحث وظهور الروابط في منصات التواصل الاجتماعي', to: {name: 'store-seo-settings'}},
                {icon: 'mdi-facebook', color: 'indigo', title: 'حسابات التواصل الاجتماعي', subtitle: 'إعدادات حسابات التواصل الاجتماعي وواتساب', to: {name: 'store-social-settings'}},
            ]
        }
    },
    computed: {
        ...GlobalComputed,

    },
    methods: {
        ...GlobalMethods,
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    mounted(){
        
    }
};
</script>
